export default function getInitState() {
    return {
        additionalTableOptions: {
            server_mode: true,
            global_search: {
                visibility: false,
            }
        },
        patientActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Munkavállaló hozzáadása',
                event_name: "customClick",
                class: "btn btn-info my-custom-class",
                event_payload: 'showAddEmployees'
            }
        ],
        employeesFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToEmployeesGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetEmployeesForm'
            },
            {
                btn_text: 'Mentés',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveNewEmployees'
            },

        ],
        patientRowActions: [
            {
                btn_text: '<i class="fas fa-exchange-alt"></i>',
                title: 'Munkavállaló áthelyezése',
                event_name: "customClick",
                class: "btn btn-outline-info",
                seeCaseOfDeleted: false,
                event_payload: 'movePatientRow'
            },
            {
                btn_text: '<i class="fas fa-file-signature"></i>',
                title: 'Jogviszony szerkesztése',
                event_name: "customClick",
                class: "btn btn-outline-info",
                seeCaseOfDeleted: false,
                event_payload: 'employmentRelationshipEdit'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                seeCaseOfDeleted: false,
                event_payload: 'deletePatientRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeletePatientRow'
            }
        ],
       
        getHeaderFields: [
            {
                name: "id",
                label: "GroupPatient ID",
                visibility: false
            },
            {
                name: "id",
                label: "Patient ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                formVisible: true
            },
            {
                name: "employeeId",
                label: "Vállalati azonosító (törzsszám)"
            },
            {
                name: "phoneNumber",
                label: "Telefonszám"
            },
            {
                name: "workEmail",
                label: "Munkahelyi E-mail"
            },
            {
                name: "motherName",
                label: "Anyja neve",
            },
            {
                name: "dateOfBirth",
                label: "Születés dátuma",
                slot_name: "date_format"
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ"
            },
            {
                name: "hierarchyString",
                label: "Munkahely"
            },
            {
                name: "supervisorNames",
                label: "Felettesek",
            },
            {
                name: "employmentRelationshipStartDate",
                label: "Jogviszony kezdete",
                slot_name: "resultDate_format",
                formVisible: true,
                formSize: 4,
                formType: "date",
                formRequired: false
            },
            {
                name: "isConnectedToManager",
                label: "Menedzser",
                formVisible: false,
                visibility: true,
                slot_name: "isConnectedToManagerFormat",
            },
            {
                name: "employmentRelationshipEndDate",
                label: "Jogviszony vége",
                slot_name: "startDate_format",
                formVisible: true,
                formSize: 4,
                formType: "date"
            },
            {
                name: "status",
                label: "Státusz",
                slot_name: "formatEmployeeStatus",
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}